module.exports = __webpack_public_path__ + "img/speaker-high-volume.2697aad7.png";